import { useEffect } from 'react';

import { useSaved } from './use-saved';

type WindowEventMapExtended = WindowEventMap & {
  'resize:height': UIEvent;
  'resize:width': UIEvent;
};

export const useWindowEventListener = <K extends keyof WindowEventMapExtended>(
  type: K,
  listener: (this: Window, ev: WindowEventMapExtended[K]) => void,
  options?: boolean | AddEventListenerOptions,
  deps?: React.DependencyList
) => {
  const savedListener = useSaved(listener);
  const savedOptions = useSaved(options);

  useEffect(() => {
    const eventListener = function (
      this: Window,
      ev: WindowEventMapExtended[K]
    ) {
      savedListener.current.bind(this)(ev);
    };

    const eventOptions = savedOptions.current;

    window.addEventListener(
      type,
      eventListener as EventListenerOrEventListenerObject,
      eventOptions
    );

    return () => {
      window.removeEventListener(
        type,
        eventListener as EventListenerOrEventListenerObject,
        eventOptions
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedListener, savedOptions, type, ...(deps ?? [])]);
};
